const DEFAULT_BUTTON_CLICK_DEBOUNCE_MS = 500;
const buttonLastClickAt = new WeakMap<HTMLButtonElement, number>();

let removeButtonClickDebounceListener: (() => void) | null = null;

export function installButtonClickDebounce(delayMs = DEFAULT_BUTTON_CLICK_DEBOUNCE_MS): void {
  if (typeof document === "undefined" || removeButtonClickDebounceListener) return;

  const handleClick = (event: MouseEvent) => {
    const target = event.target;
    if (!(target instanceof Element)) return;

    const button = target.closest("button");
    if (!button || button.disabled || button.dataset.debounce === "off") return;

    const now = performance.now();
    const lastClickAt = buttonLastClickAt.get(button) ?? 0;
    if (now - lastClickAt < delayMs) {
      event.preventDefault();
      event.stopImmediatePropagation();
      return;
    }

    buttonLastClickAt.set(button, now);
  };

  document.addEventListener("click", handleClick, true);
  removeButtonClickDebounceListener = () => {
    document.removeEventListener("click", handleClick, true);
    removeButtonClickDebounceListener = null;
  };
}

